import { useQuery } from "@tanstack/react-query";
import { Dashboard } from "../../types";
import { dashboardService } from "../../services/dashboardService";

export const useDashboard = (dashboardId?: string) => {
  return useQuery<Dashboard>({
    enabled: !!dashboardId,
    queryKey: ["dashboard", dashboardId],
    retry: false,
    queryFn: async () => {
      const r = await dashboardService.get(dashboardId!);
      if(!r) {
        throw new Error("Dashboard not exist");
      }
      return r;
    },
  });
};
